import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService} from '../../shared';
import {Core2Config} from '../../shared';
import { GenericDocContainerModel } from '../../../../../../models';
import { Observable } from 'rxjs';


//https://api.akaun.cloud/core2/tnt/dm/ecom/internal-shopping-carts

@Injectable({providedIn: 'root'})
export class ShoppingCartCustomerAccessService extends BaseApiTemplateService<GenericDocContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_ECOM_URL_PREFIX + 'internal-shopping-carts';
    this.endpoint_path = Core2Config.TENANT_ECOM_URL_PREFIX + 'internal-shopping-carts';
    this.httpClient = http;
  }

  public discard(guid: String, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl =
        apiVisa.api_domain_url +
        this.endpoint_path +
        "/discard/backoffice-ep/" +
        guid;
    }
    // return this.httpClient.put(this.apiUrl, null, this.getHttpHeader(apiVisa));
    return this.httpClient.put<ApiResponseModel<GenericDocContainerModel>>(
      this.apiUrl,
      null, //empty body
      this.getHttpHeader(apiVisa)
    );
  }

  public printJasperPdf(
    guid: string,
    printServiceClassName: string,
    printableFormatGuid: string,
    apiVisa: ApiVisa,
    customParam?: string
  ): Observable<Blob> {
    let params;
    let url;
    if (customParam) {
      params = new HttpParams()
        .set("printServiceClassName", printServiceClassName)
        .set("printableFormatHdrGuid", printableFormatGuid);
      // .set('customParam', customParam);
    } else {
      params = new HttpParams()
        .set("printServiceClassName", printServiceClassName)
        .set("printableFormatHdrGuid", printableFormatGuid);
    }
    url =
      apiVisa.api_domain_url + this.endpoint_path + "/print-jasper-pdf/" + guid;
    return this.httpClient.get<Blob>(
      url,
      this.getHttpHeaderBlob(apiVisa, params)
    );
  }

}
